import classNames from "classnames";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

import { supportEmail } from "@utils/membership/membershipUtils";
import { PlayerSowStoreContext } from "@state/context/sow/PlayerSowStoreContext";
import { Link } from "react-router-dom";
import { getCurrentCulture } from "@utils";

export default function PlayerSowInfo(props: { isFullForm?: boolean }) {
	const [toggleFilter, setToggleFilter] = useState(true);
	const { t } = useTranslation("account-verification");

	const playerSowStore = useContext(PlayerSowStoreContext);

	if (!playerSowStore) {
		return null;
	}

	const accordionHeaderClass = classNames(
		"card--primary__header btn btn--block btn--reset u-padd--xsml",
		{
			"is-expanded": toggleFilter,
			"is-collapsed": !toggleFilter,
		}
	);

	const accordionIconClass = classNames("u-icon u-icon--sml", {
		"u-icon--caret--up": toggleFilter,
		"u-icon--caret--down": !toggleFilter,
	});

	return (
		<>
			<div className="u-type--base">{t("PLAYER_SOW.INFO")}</div>
			{playerSowStore.submissionStatusReason && (
				<div className="u-mar--top--xsml">
					{!playerSowStore.isFormRequired ? (
						<div className="u-type--wgt--medium">
							{t("PLAYER_SOW.REASON_TITLE_DOCUMENTS")}
						</div>
					) : (
						<div className="u-type--wgt--medium">
							{t("PLAYER_SOW.REASON_TITLE")}
						</div>
					)}
					<div className="u-mar--top--xsml u-type--wgt--medium">
						{t("PLAYER_SOW.REASON_PARAGRAPH")}
					</div>
					<div className="u-color--text--secondary u-type--style--italic">
						"{playerSowStore.submissionStatusReason}"
					</div>
				</div>
			)}
			<div className="card--bordered card--primary u-mar--top--big">
				<button
					type="button"
					className={accordionHeaderClass}
					onClick={() => setToggleFilter(!toggleFilter)}
				>
					<span className="card--primary__title u-type--base u-type--left u-type--wgt--bold">
						{t("INSTRUCTIONS")}
					</span>
					<i className={accordionIconClass} />
				</button>
				{toggleFilter && (
					<div className="card--primary__body u-padd--xsml u-type--sml u-color--text--secondary">
						{props.isFullForm && (
							<div className="card--primary__section">
								<div className="u-mar--bottom--xtny">
									{t("PLAYER_SOW.INSTRUCTIONS.TITLE")}
								</div>
							</div>
						)}
						<div className="card-primary__section">
							<div className="u-mar--bottom--xtny">
								{t("PLAYER_SOW.UPLOAD_GUIDELINES.TITLE")}
							</div>
							<ol className="list list--ordered">
								<li className="u-mar--bottom--xtny">
									{t(
										"PLAYER_SOW.UPLOAD_GUIDELINES.DOCUMENT_FORMATS"
									)}
								</li>
								<li className="u-mar--bottom--xtny">
									{t(
										"PLAYER_SOW.UPLOAD_GUIDELINES.DOCUMENT_SIZE"
									)}
								</li>
								<li className="u-mar--bottom--xtny">
									{t(
										"PLAYER_SOW.UPLOAD_GUIDELINES.DOCUMENT_QUALITY"
									)}
								</li>
							</ol>
						</div>

						<div>
							{t(
								"PLAYER_SOW.UPLOAD_GUIDELINES.SUPPORT_EMAIL_MESSAGE",
								{
									email: supportEmail,
								}
							)}
						</div>
						<div className="u-type--right">
							<Link
								to={`/${getCurrentCulture()}/support-chat`}
								className="card--empty__btn btn btn--sml btn--accent btn--icon btn--animate-forward u-mar--top--xsml u-type--align--right"
								target="_blank"
							>
								{t("CHAT.SUPPORT.TITLE")}{" "}
								<i className="u-icon u-icon--tny u-icon--arrow-right u-color--accent--text" />
							</Link>
						</div>
					</div>
				)}
			</div>
		</>
	);
}
